import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureType } from '@core/models/features/feature.model';
import { FeatureService } from '@core/services/feature.service';
import { Subject, takeUntil } from 'rxjs';

@Directive({
    selector: '[hasFeature]',
    standalone: false
})
export class HasFeatureDirective implements OnInit, OnDestroy {

    constructor(
        private viewContainerRef: ViewContainerRef,
        private templateRef: TemplateRef<any>,
        private fs: FeatureService
    ) {}

  private feature!: string|FeatureType;
  private hasView = false;
  private stopRequesting = new Subject<void>();

  @Input()
  set hasFeature(f: string|FeatureType) {
    this.feature = f;
  }

  ngOnInit() {
    this.fs.features$.pipe(takeUntil(this.stopRequesting)).subscribe(() => {
      this.updateView();
    });
  }

  private updateView() {
    const hasFeature = this.fs.hasFeature(this.feature as FeatureType);
    if (hasFeature && !this.hasView) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasFeature && this.hasView) {
      this.viewContainerRef.clear();
      this.hasView = false;
    }
  }

  ngOnDestroy() {
    this.stopRequesting.next();
    this.stopRequesting.complete();
  }
}
